import { IconType } from "react-icons"
import { MdFormatListBulleted } from "react-icons/md"
import { TbPerfume } from "react-icons/tb"

export enum Division {
  Household = 'Household',
  Toiletry = 'Toiletry'
}
export enum OrderType {
  All = 'All',
  Mixing = 'Mixing',
  Filling = 'Filling'
}

export enum MaterialType {
  RAW = 'RAW', PKG = 'PKG'
}

export enum PicklistStatus {
  PD_RELEASED = 'PD_RELEASED',
  PD_REQUESTED = 'PD_REQUESTED',
  WH_SHORTAGE = 'WH_SHORTAGE',
  WH_APPROVED = 'WH_APPROVED',
  PD_CHECKED = 'PD_CHECKED',
  PD_RECORDED = 'PD_RECORDED',
  PICKLIST_COMPLETED = 'PICKLIST_COMPLETED',
  QA_CHECKED = 'QA_CHECKED'
}

export enum PicklistStatusDesc {
  PD_RELEASED = 'รออนุมัติ',
  PD_REQUESTED = 'อนุมัติเบิกแล้ว',
  WH_SHORTAGE = 'รอของเข้า',
  WH_APPROVED = 'อนุมัติจ่ายแล้ว',
  PD_CHECKED = 'PD ตรวจสอบแล้ว',
  PD_RECORDED = 'บันทึกยอดใช้แล้ว',
  PICKLIST_COMPLETED = 'ปิดเอกสารแล้ว',
  QA_CHECKED = 'PD ตรวจ RM แล้ว'
}

export enum CheckMethod {
  BY_ORDER, BY_MATERIAL
}
export enum CheckMethodDesc {
  BY_ORDER = 'นับตาม Order', 
  BY_MATERIAL = 'นับตาม Material'
}

export enum PicklistReturnStatusDesc {
  NEW = 'รออนุมัติ',
  APPROVED = 'อนุมัติแล้ว',
  CANCELED = 'ยกเลิก'
}

export enum SubmitState {
  INIT, SUBMITTING, COMPLETED, FAILED
}

export enum DisplayMode {
  TABLE, CARD
}

export enum MovementType {
  ISSUE = '261', RETURN = '262'
}

type ReportField = {
  id: number,
  title: string,
  className: string,
  icon: IconType
}

const OrderListReport : ReportField = {
  id: 1,
  title: 'รายการ Order(s)',
  className: ' text-green-700',
  icon: MdFormatListBulleted
}

const FragranceReport : ReportField = {
  id: 2,
  title: 'ยอดน้ำหอม',
  className: ' text-rose-500',
  icon: TbPerfume
}

export const ExcelMenus = {
  'bulk': [FragranceReport, OrderListReport],
  'fg': [OrderListReport]
}

export enum FGInspectionTypes {
  PD_FILLING = 'PD_FILLING',
  PD_PACKING = 'PD_PACKING',
  QC_FILLING = 'QC_FILLING',
  QC_PACKING = 'QC_PACKING'
}

export const SHIFT = {
  ROMKLAO: { display: 'ร่มเกล้า', value: '1' },
  MINBURI: { display: 'มีนบุรี', value: '2' }
}